(() => {
  // app/scripts/lazy-menu.js
  var LazyMenu = class _LazyMenu extends HTMLElement {
    constructor() {
      super();
      this._isLoaded = false;
    }
    connectedCallback() {
      if (!this._isLoaded) {
        this.style.display = "none";
        this._isLoaded = true;
        window.LazyMenu = this;
        window.LazyMenu.restoreLazyMenu = _LazyMenu.restoreLazyMenu;
      }
    }
    showAndReplace() {
      this.style.display = "";
      const details = this.closest("details.js-mega-nav");
      if (!details)
        return;
      while (this.firstChild) {
        details.insertBefore(this.firstChild, this);
      }
      this.remove();
    }
    // Khi mà close rồi phải trả về thẻ lazy-menu lại
    static restoreLazyMenu(detailsEl) {
      if (detailsEl && !detailsEl.querySelector("lazy-menu")) {
        const lazyMenu = document.createElement("lazy-menu");
        let node = detailsEl.firstChild;
        const nodesToMove = [];
        while (node) {
          if (node.nodeType === Node.ELEMENT_NODE && (node.tagName === "SUMMARY" || node.tagName === "LAZY-MENU" || node.tagName === "DETAILS")) {
            node = node.nextSibling;
            continue;
          }
          if (node.nodeType === Node.ELEMENT_NODE && (node.classList.contains("main-nav__child") || node.classList.contains("child-nav--dropdown") || node.classList.contains("mega-nav--columns") || node.classList.contains("mega-nav--sidebar"))) {
            nodesToMove.push(node);
          }
          node = node.nextSibling;
        }
        nodesToMove.forEach((el) => {
          lazyMenu.appendChild(el);
        });
        detailsEl.appendChild(lazyMenu);
      }
    }
  };
  customElements.define("lazy-menu", LazyMenu);
})();
